import React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import useAuth from "src/hooks/useAuth";

export default function ItemInfo({ value, remainingCount }) {
  const { user } = useAuth();
  const { settings } = user.company;
  const showStagedStatus = settings?.scan_to_staging_area_for_inventory_request;
  const isPlaceholderItem = value.placeholderForGroupedAsset;

  if (isPlaceholderItem) {
    return (
      <Box>
        <Typography variant="body2" color="text.secondary" fontWeight={500}>
          Placeholder Item
        </Typography>
        <Typography variant="body1" color="error" fontWeight={500} mt={0.5}>
          Add {remainingCount ?? value.quantity} {value.asset?.description || "items"} serial {(remainingCount ?? value.quantity) === 1 ? "number" : "numbers"} to this order
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {showStagedStatus && (
        <Chip
          label={value.stagedStatus ? "Staged" : "Not Staged"}
          size="small"
          sx={{ borderRadius: 1, bgcolor: value.stagedStatus ? "#D5F5D5" : "#F8D7DA", fontWeight: 500 }}
        />
      )}
      <Chip
        label={value.pickedStatus ? "Picking Complete" : "Not Picked"}
        size="small"
        sx={{ borderRadius: 1, bgcolor: value.pickedStatus ? "#D5F5D5" : "#F8D7DA", fontWeight: 500 }}
      />
    </Box>
  );
}


